/**
 *
 * ReceptionDxGrid14326
 *
 */

import { ReceptionDxGrid } from "pages/Rules/ReceptionView/ReceptionDxGrid";
import { rulesColumnSizes } from 'domain/typeConstants/table';
import { ACTIVE_RULES } from "domain/Data/Filters/constants";

export class ReceptionDxGrid14326 extends ReceptionDxGrid {

  NEWS_TOPIC = 'newsTopic'

  getFilters() {
    const { viewName } = this.props;
    let filters = super.getFilters();
    if (viewName === 'allDocumentsRules') filters.push(ACTIVE_RULES);
    return filters;
  }

  isNews() {
    const { viewName } = this.props;
    return viewName === 'allNews';
  }

  getColumns() {
    let columns = super.getColumns();
    this.isNews() &&
      columns.push({
        path: this.NEWS_TOPIC,
        name: this.NEWS_TOPIC,
        title: 'Тема',
      });
    return columns;
  }

  getColumnWidths() {
    let columnWidths = super.getColumnWidths();
    this.isNews() &&
      columnWidths.push({ columnName: this.NEWS_TOPIC, width: rulesColumnSizes.newsTopic })
    return columnWidths
  }

  getColumnOrder() {
    let columnOrder = super.getColumnOrder()
    if (this.isNews()) {
      const contentIndex = columnOrder.findIndex((item) => item === 'content');
      columnOrder.splice(contentIndex, 0, this.NEWS_TOPIC);
    }
    return columnOrder;
  }

}


